var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"black","font-size":"30px","padding-top":"10%"}},[_vm._v("待开发")])
}
var staticRenderFns = []

export { render, staticRenderFns }